import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { some } from 'lodash'
import { ListGroup, Panel, FormControl } from 'react-bootstrap'

import Task from './Task.jsx'
import {l} from '../../lib/Tools.js'
import Button from '../components/Button.jsx'
import ModalTaskEditor from './ModalTaskEditor.jsx'

import { 
  getThisUserPendingTasks, getUsernames, getThisUsername, makeGetUserTasks 
} from '../selectors'

import { 
  createTask, createTaskForThisUser, updateTask, removeTask 
} from '../ducks/tasks'

import { getText } from '../lib/text.js'

/**
 * 
 */

type SelectUserProps = {
  usernames: string[], 
  onChange: string => void,
  value: string
}

const SelectUser = ({ usernames, onChange, value }: SelectUserProps) => (
  <FormControl
    componentClass="select"
    value={value}
    onChange={evt => onChange(evt.target.value)}
  >
    {
      usernames.map(u => <option value={u} key={u}>{u}</option>)
    }
  </FormControl>
)

/**
 * 
 */

type Props = {
  thisUserPendingTasks: Object[], 
  getUserPendingTasks: string => Object[], 
  removeTask: (string) => void, 
  updateTask: (string, Object) => void, // (idx, changes)
  addTask: () => void,
  thisUser: string, 
  users: string[]
}

class UserTasksViewer extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showSelect: false, 
      selectedUser: null,
      editingTask: null
    }
  }

  props: Props

  renderTasks(title, tasks) {
    if (tasks.length == 0) return null

    return (
      <div>
        <h4>{title}</h4>
        {
          tasks.map(task => (
            <Task
              includeTrip
              key={`${task._id}`}
              task={task}
              onChange={changes => this.props.updateTask(task._id, changes)}
              onEdit={() => this.openTask(task._id)}
              active={false}
            />
          ))
        }
      </div>
    )
  }

  addTask(user) {
    this.props.addTask(user, id => {
      this.openTask(id)
    })
  }

  openTask(id) {
    this.setState({ editingTask: id })
  }

  render() {
    const today = moment().format("YYYY/MM/DD")
    const tomorrow = moment().add(1, "days").format("YYYY/MM/DD")

    const tasks = (
      this.state.showSelect 
        ? this.props.getUserPendingTasks(this.state.selectedUser || this.props.thisUser) 
        : this.props.thisUserPendingTasks
    )

    const editingTask = tasks.find(t => t._id == this.state.editingTask)

    const rt = [
      this.renderTasks("Tareas atrasadas", tasks.filter(task => task.dueDate < today)),
      this.renderTasks("Tareas de hoy", tasks.filter(task => task.dueDate == today)),
      this.renderTasks("Tareas de mañana", tasks.filter(task => task.dueDate == tomorrow)),
      this.renderTasks("Otras tareas", tasks.filter(({dueDate}) => !dueDate || dueDate > tomorrow)),
    ]

    const noTasks = !some(rt)

    return (
      <Panel>
        <Panel.Heading>
          <Panel.Title>
            {
              this.state.showSelect ? getText("Tareas pendientes de...") : getText("Tus tareas pendientes")
            }
            <div style={{float:"right"}}>
              { 
                this.state.showSelect
                  ? (
                    <SelectUser 
                      value={this.state.selectedUser || this.props.thisUser} 
                      onChange={selectedUser => this.setState({selectedUser})}
                      usernames={this.props.users}
                    />
                  )
                  : (
                    <Button bsSize="xsmall" onClick={() => this.setState({showSelect: true})}>
                      {getText("Ver tareas de...")}
                    </Button>
                  )
              }
            </div>
          </Panel.Title>
        </Panel.Heading>

        <Panel.Body>
          <ListGroup>
            {rt.map(x => x || "")}
            {noTasks && <div style={{fontSize: "1.2em", textAlign: "center"}}>😬 <i>No tienes tareas</i></div>}
          </ListGroup>

          {
            editingTask 
              ? (
                <ModalTaskEditor
                  task={editingTask}
                  onChange={changes => this.props.updateTask(this.state.editingTask, changes)}
                  onRemove={() => this.props.removeTask(this.state.editingTask)}
                  onClose={() => this.setState({ editingTask: null })}
                />
              )
              : ""
          }
          
          <Button 
            glyph="plus"
            onClick={() => this.props.addTask(this.state.selectedUser)}
          >
            {getText("Añadir tarea")}
          </Button>
        </Panel.Body>
      </Panel>
    )
  }
}

const stateToProps = (state, props) => ({
  thisUserPendingTasks: getThisUserPendingTasks(state, props), 
  getUserPendingTasks: makeGetUserTasks(state, props), 
  thisUser: getThisUsername(state, props), 
  users: getUsernames(state, props)
})

const dispatchToProps = (dispatch) => ({
  removeTask: (id) => dispatch(removeTask(id)), 
  updateTask: (id, changes) => dispatch(l(updateTask(id, changes))), 
  addTask: (user, cb) => {
    if (user) dispatch(createTask({ user }, id => cb && cb(id)))
    else dispatch(createTaskForThisUser({}, id => cb && cb(id)))
  }
})

export default connect(stateToProps, dispatchToProps)(UserTasksViewer)
